






























































































































































































































import Vue from 'vue';
import validate from '@/utils/validate';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { TCourseInfo, TTeacher } from '@/types/views/educational';
import { TRules } from '@/types/utils';
import {
  getTeachers,
  updateCourse,
  deleteCourse,
  publishCourse
} from '@/api/educational';
@Component({})
export default class Info extends Vue {
  @Prop({
    type: Object,
    required: true
  })
  courseInfo!: TCourseInfo;

  @Prop({
    type: Function,
    default() {
      return function() {};
    }
  })
  getData!: Function;

  @Watch('className')
  watchClassName(val: string, oldVal: string) {
    if (!val) {
      return this.courseInfo.courseName;
    }
    return this.courseInfo.className;
  }

  get className() {
    return this.courseInfo.className;
  }

  private teachers: TTeacher[] = [];
  private rules: TRules = {
    timeDes: [
      {
        required: true,
        validator: validate.validatorTimeDes_rule,
        trigger: 'blur'
      }
    ],
    price: [
      {
        required: true,
        validator: validate.validatorPrice_rule,
        trigger: 'blur'
      }
    ],
    originalPrice: [
      {
        required: true,
        validator: validate.validatorPrice_rule,
        trigger: 'blur'
      }
    ],
    startTime: [
      {
        required: true,
        message: '请输入正确时间',
        trigger: 'blur'
      }
    ],
    endTime: [{ required: true, message: '请输入正确时间', trigger: 'blur' }],
    mainTeacherId: [{ required: true, message: '请选择老师', trigger: 'blur' }],
    assitantTeacherId: [
      { required: true, message: '请选择老师', trigger: 'blur' }
    ],
    minutes: [
      {
        required: true,
        validator: validate.validatorNumber_rule,
        trigger: 'blur'
      }
    ]
  };
  private mounted() {
    this.getTeachers();
  }
  private addLessonList() {
    this.courseInfo.freqList.push({
      frequenceType: '每周一',
      date: new Date()
    });
  }
  private deleteLessonList(index: number) {
    this.courseInfo.freqList.splice(index, 1);
  }
  private async getTeachers() {
    try {
      let res: any = await getTeachers();
      this.teachers = res.list;
    } catch (e) {
      this.$message.error(e.message);
    }
  }
  private async updateCourse() {
    try {
      // this.courseInfo.className == '' ? this.courseInfo.courseName : this.courseInfo.className
      const data = await updateCourse({
        courseDTOStr: JSON.stringify({
          ...this.courseInfo,
          courseId: parseInt(this.$route.params.id),
          teachingMatId: this.courseInfo.teachingMaterialId
        })
      });
      data && this.$message.success('班级更新成功');
      this.$router.push('/educational/course');
    } catch (e) {
      this.$message.error(e.message);
    }
  }
  private update() {
    const time = (this.courseInfo as any).startTime;
    this.courseInfo.startTime = new Date(time).getTime() + '';
    let classDateArr = [];
    for (let item of this.courseInfo.freqList) {
      classDateArr.push(item.frequenceType);
    }
    this.courseInfo.classDate = classDateArr.join('  ');
    (this.$refs['form'] as any).validate(async (valid: boolean) => {
      if (valid) {
        delete this.courseInfo.lessonList;
        delete this.courseInfo.mainTeacher;
        delete this.courseInfo.assitantTeacher;
        this.updateCourse();
      } else {
        this.$message.warning('请填写完整');
        return false;
      }
    });
  }
  private async publishCourse() {
    try {
      const data = await publishCourse({
        courseId: parseInt(this.$route.params.id) + ''
      });

      if (data.code === '000001') {
        this.$message.success('班级发布成功');
        this.getData();
      }
    } catch (e) {
      this.$message.error(e.message);
    }
  }
  private delete() {
    this.$confirm('删除后将不可恢复?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        this.deleteCourse();
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
  }
  private async deleteCourse() {
    try {
      const data = await deleteCourse({
        courseId: this.$route.params.id
      });
      this.$message({
        type: 'success',
        message: '删除成功'
      });
      this.$router.push('/educational/course');
    } catch (e) {
      this.$message.error(e.message);
    }
  }
  private validatorDateE(rule: any, value: any, callback: Function) {
    let d = new Date(value) + '';
    if (d.toString() === 'Invalid Date') {
      callback(new Error('非法时间格式'));
    } else if (value < (this.courseInfo as any).startTime) {
      callback(new Error('结束日期不能小于开始日期'));
    } else {
      callback();
    }
  }
}
